export const ADMIN_ORGANIZATION_USERS_INVITE_FORM = 'inviteForm'
export const ADMIN_ORGANIZATION_USERS_INVITE_FORM_BULK_SECTION = 'inviteFormBulkSection'
